<template>
  <div class="wrapper">
    <h1><span class="logo">MA CARTE BEAUTÉ</span> Import des codes MID</h1>
    <div class="onglets">
      <ul>
        <li class="active">
          <h2><i class="fas fa-chart-bar"></i> Logs</h2>
        </li>
        <li><!-- <h2>Import de points</h2> --></li>
      </ul>
      <div class="contenu">
        <h2>VISUALISATION DES LOGS :</h2>
        <div class="preview">
          <table>
            <thead>
              <tr>
                <th scope="col">Client</th>
                <th scope="col">MID Ajoutés</th>
                <!-- <th scope="col">Email</th> -->
                <th scope="col">MID A jour</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr class="rTableRow" v-for="item in logs" :key="item._id">
                <td data-label="login">{{ item.client }}</td>
                <td data-label="login">{{ item.add }}</td>
                <!-- <td data-label="email">{{ item.Email }}</td> -->
                <td data-label="nom">{{ item.update }}</td>
                <td data-label="nom">{{ item.updatedAt }}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <router-link tag="button" class="blue" :to="`/client/${client}`"
            ><span>Retour</span></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios").default;
const baseUrl =
  process.env.NODE_ENV == "production" || process.env.NODE_ENV == "staging"
    ? ""
    : "http://localhost:3000";

export default {
  data() {
    return {
      logs: {},
    };
  },
  async created() {
    if (localStorage.client != "mcb") {
      this.$router.replace("/client/" + localStorage.client);
    } else {
      this.client = localStorage.client;
    }

    axios.get(baseUrl + "/get_logs/").then((response) => {
      this.logs = response.data;
    });
  },
};
</script>
